"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, (0, vue_1.toDisplayString)(_ctx.player === undefined ? "" : _ctx.player.name), 1));
}
